<template>
    <div class="book-a-class">
        <div class="course-head" id="course-head">
            <div class="course-title max-width-box">{{ courseInfo.courseName || "-" }}</div>
            <div class="course-rate max-width-box">
                <span style="margin-right: 8px; color: #f48c06">{{ courseInfo.avgscore }}</span>

                <el-rate v-model="courseInfo.avgscore" disabled text-color="#ff9900" score-template="{value}">
                </el-rate>
                <span style="height: 100%; width: 1px; margin-right: 16px">|</span>
                <span>{{ courseInfo.viewtimes }} Reviews</span>
            </div>
        </div>
        <div class="bookclass-body max-width-box" id="bookclass-body">
            <div class="left">
                <div class="bookclass-body-title" v-if="step === 0">
                    <div>Schedule</div>
                </div>

                <div class="bookclass-body-time" v-if="step === 0">
                    <div class="bookclass-time-date">
                        {{ monthEnglish[nowMonth] + " " + nowYear }}
                    </div>
                    <div class="bookclass-time-oprate">
                        <i class="el-icon-arrow-left" @click="goPrevMonth" :class="{ 'can-select': canGoPre }"></i>
                        <i class="el-icon-arrow-right" @click="goNextMonth" :class="{ 'can-select': canGoNext }"></i>
                    </div>
                </div>

                <div class="select-box" v-if="step === 0">
                    <div class="select-item-box" v-for="(item, index) in courseTimeList" :key="index">
                        <div class="select-item" @click.prevent="checkItem(item)">
                            <span>{{ item.apdate }} {{ item.week }}: {{ item.starttime }} -
                                {{ item.endtime }}</span>
                            <el-checkbox v-model="isChecked[item.id]" @click.stop.prevent=""></el-checkbox>
                        </div>
                    </div>

                    <div v-if="courseTimeList.length === 0">View next month for available time</div>
                </div>

                <h1>Selected</h1>
                <!-- 未下单时展示 -->
                <div class="select-box" v-if="step === 0">
                    <div class="select-item-box" v-for="(item, index) in checkedCourseList" :key="index">
                        <div class="select-item" @click.prevent="checkItem(item)">
                            <span>{{ item.apdate }} {{ item.week }}: {{ item.starttime }} -
                                {{ item.endtime }}</span>
                            <el-checkbox v-model="isChecked[item.id]" @click.stop.prevent=""></el-checkbox>
                        </div>
                    </div>
                </div>
                
                <!-- 已下单时展示选中 -->
                <div class="select-box" v-if="step === 1">
                    <div class="select-item-box" v-for="(item, index) in orderDetail.covey_calendars" :key="index">
                        <div class="select-item">
                            <span>{{ item.apdate }} {{ item.week }}: {{ item.starttime }} -
                                {{ item.endtime }}
                            </span>
                        </div>
                    </div>
                </div>

                <h1>Coupon</h1>
                <!-- 未下单时展示 -->
                <div class="select-box" v-if="step === 0">
                    <div class="select-item-box" v-for="(item, index) in couponList" :key="index" :class=" totalNum * unitPrice < (item.with_amount / 100).toFixed(2) ? 'coupon-disable' : '' ">
                        <div class="select-item" @click.prevent="checkCoupon(item)" :class="{ 'coupon-disable': totalNum * unitPrice < (item.with_amount / 100).toFixed(2), }">
                            <span>{{ item.title }}</span>
                            <el-checkbox v-model="isCouponChecked[item.id]" @click.stop.prevent="" :disabled=" totalNum * unitPrice < (item.with_amount / 100).toFixed(2) ">
                            </el-checkbox>
                        </div>
                    </div>
                </div>
                <!-- 已下单时展示选中 -->
                <div class="select-box" v-if="step === 1 && orderDetail.covey_coupon">
                    <div class="select-item-box" >
                        <div class="select-item" >
                            <span>{{ orderDetail.covey_coupon.title }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="step === 1 && !orderDetail.covey_coupon">Unused coupon</div>
            </div>

            <div class="right" v-if="step === 0">
                <div class="order-back" v-if="false">
                    <i class="el-icon-loading"></i>Submitting an order...
                </div>
                <div class="order-container">

                    <div class="bookclass-order-title">Order options</div>
                    <div class="bookclass-order-box">
                        <div class="bookclass-order-price">
                            <div class="order-price-item" style="margin-bottom: 12px">
                                <div>Amount:</div>
                                <div>{{ totalNum }}</div>
                            </div>
                            <div class="order-price-item">
                                <div>Original Price:</div>
                                <div>C${{ originalPrice }}</div>
                            </div>
                        </div>

                        <div class="bookclass-order-price">
                            <div class="order-price-item" style="margin-bottom: 12px">
                                <div>Actual Price:</div>
                                <div>C${{ unitPrice }}</div>
                            </div>

                            <div class="order-price-item">
                                <div>Coupon Amount:</div>
                                <div>- C${{ coupon }}</div>
                            </div>
                        </div>

                        <div class="bookclass-order-price">
                            <div class="order-price-item" style="margin-bottom: 12px; font-size: 20px">
                                <div>Discount:</div>
                                <div>- C${{ discount }}</div>
                            </div>

                            <div class="order-price-item">
                                <div>Service Fee:</div>
                                <div>+ C${{ tax }}</div>
                            </div>
                        </div>
                        <div class="bookclass-order-total">
                            <div class="bookclass-order-pay">
                                <span class="tt">Total:</span>
                                <span> C$ {{ total }} </span>
                            </div>
                        </div>

                        <el-button class="my-button" :loading="nextLoading" @click="handleBookOrder">Continue to Order</el-button>
                    </div>
                    <div>
                        <div class="course-price-box" v-if="coursePrice.length > 0">
                            <div class="course-price" v-for="(item, index) in coursePrice" :key="index">
                                <img src="@/assets/icon/yes.png" />
                                {{ item.book_amount }} Lesson / C${{ (item.price / 100).toFixed(2) }} Session (1 hour)
                            </div>
                        </div>
                        <div class="course-price-box" v-else>
                            Contact your tutor for a big discount !
                        </div>
                    </div>

                </div>

                <!-- @click.stop.native="" 防止点击冒泡 -->
                <!-- todo 格式化时间为am pm -->
                <!-- <div class="my-button"  >Next</div> -->
            </div>

            <div class="right" v-if="step === 1">
                <div class="order-box">
                    <h1>{{ courseInfo.courseName }}</h1>
                    <div class="order-price-item" style="margin-bottom: 12px">
                        <div>Order Price:</div>
                        <div>C${{ orderDetail.order_money | formatMoneyNumber }}</div>
                    </div>

                    <div class="order-price-item" style="margin-bottom: 12px">
                        <div>Coupon Price:</div>
                        <div>C${{ orderDetail.coupon_money | formatMoneyNumber }}</div>
                    </div>

                    <div class="bookclass-order-pay">
                        <span class="tt">Total:</span>
                        <span>
                            C$ {{ orderDetail.pay_money | formatMoneyNumber }}
                        </span>
                    </div>
                    <div style="display: flex; justify-content: space-between;font-size:12px;margin-top:14px;">
                        <span>Type of payment</span>
                        <span>100% secure</span>
                    </div>

                    <div class="my-card"><img src="@/assets/icon/paypal.svg" /></div>
                    <el-button class="my-button" @click="paytheOrder" :loading="paypalLoading" v-if="!isFinishedPay">Pay with paypal</el-button>
                    <div v-else class="success-pay">Payment Success！</div>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="isWaitingVisible" :close-on-click-modal="false" :show-close="false" custom-class="waitDialog">
            <div class="refresh_tips">
                Please wait patiently for the payment result, click the following button
                to refresh after payment is complete.
            </div>
            <div class="refresh_box">
                <div class="refresh_bt" @click="refreshOrderStatus">
                    Click to Continue
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { isURL } from "@/utils/comm";
export default {

    filters: {
        formatMoneyNumber(value) {
            if (typeof value === 'number' && !isNaN(value)) { //必要
                return (Number(value) / 100).toFixed(2);
            } else {
                return '-'
            }
        }
    },
    computed: {
        totalNum() {
            //实际数量
            return this.checkedCourseList.length;
        },
        unitPrice() {
            //实际单价
            let res = 0.0;
            let num = this.totalNum;

            if (this.coursePrice[0] && this.coursePrice.length === 1)
                return this.coursePrice[0].price / 100; //只有一个价格

            if (num === 0) {
                res = this.coursePrice[0] ? this.coursePrice[0].price / 100 : 0;
            } else {
                for (let i = 1; i < this.coursePrice.length; i++) {
                    if (
                        num >= this.coursePrice[i - 1].book_amount &&
                        num < this.coursePrice[i].book_amount
                    ) {
                        res = this.coursePrice[i - 1].price / 100;
                        break;
                    } else {
                        res = this.coursePrice[i].price / 100;
                        continue;
                    }
                }
            }
            return res.toFixed(2);
        },
        originalPrice() {
            //实际原价
            return (this.coursePrice[0] ? this.coursePrice[0].price / 100 : 0).toFixed(2);
        },
        discount() {
            //实际折扣
            return ((this.originalPrice - this.unitPrice) * this.totalNum).toFixed(2);
        },
        tax() {
            //税
            return (this.taxNum * this.unitPrice * this.totalNum).toFixed(2);
        },
        coupon() {
            let coupon1 = 0.0;
            if (this.selectedCoupon !== "") {
                for (let item of this.couponList) {
                    if (
                        this.selectedCoupon === item.id &&
                        (item.with_amount / 100).toFixed(2) <=
                        this.totalNum * this.unitPrice
                    ) {
                        coupon1 = (item.used_amount / 100).toFixed(2);

                        break;
                    }
                }
            } else {
                // return 'No coupons available.'
            }
            return coupon1;
        },
        total() {
            //实际支付

            return (
                (this.totalNum * this.unitPrice - this.coupon) *
                (1 + this.taxNum)
            ).toFixed(2);
        },
        //选课 的 checkbox
        isChecked: {
            get: function () {
                let res = {};
                for (let item of this.checkedCourseList) {
                    res[item.id] = true;
                }
                if (res === {}) return false;
                return res;
            },
            set: function (val) {
                
            },
        },
        //选优惠券的 checkbox
        isCouponChecked() {
            let res = {};
            for (let item of this.couponList) {
                res[item.id] = false;
                if (this.selectedCoupon === item.id) {
                    res[item.id] = true;
                }
            }
            return res;
        },
    },
    watch:{
        '$route.query':function(newVal,oldVal){
            
            this.initPage();
        }
    },
    data() {
        return {
            monthEnglish: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
            teacherId: "",
            courseId: "",
            courseInfo: {},
            teacherInfo: {},
            courseTimeList: [],
            nextLoading: false,
            step: 0,
            orderId: "", //下单成功之后返回的id
            orderDetail: {},
            coursePrice: [],
            nowMonth: 0,
            nowYear: 0,
            canGoPre: true,
            canGoNext: false,
            taxNum: 0.0,
            checkedCourseList: [],
            couponList: [], //优惠券
            selectedCoupon: "", //选中的优惠券
            paypalLoading: false,
            isWaitingVisible: false,
            isFinishedPay: false,
        };
    },
    components: {},
    created() {
        this.initPage();
        
    },
    mounted(){
    },
    methods: {
        initPage(){
            
            if (this.$route.query.orderId) {//如果有订单id进来
                this.orderId = this.$route.query.orderId;
                this.checkOrderDetailById();
            }else{
                this.teacherId = this.$route.query.teacherId;
                this.courseId = this.$route.query.courseId;
                this.getTax();
                this.getTeacherDetail();
                this.initTime().then((res) => {
                    this.getCourseTimeList();
                });
                this.getCourseDetail();
                this.getCoursePrice();
                this.getcoupon();
            }
        },
        getTax() {
            this.$api.courseApi.getTax().then((res) => {
                if (res.status === "0") {
                    this.taxNum = res.data;
                } else {
                    this.$message.error("Error!" + res.message);
                }
            });
        },
        async initTime() {
            this.nowYear = new Date().getFullYear();
            this.nowMonth = new Date().getMonth();
        },
        getTeacherDetail() {
            this.$api.courseApi
                .getDetaiTeacher({ teacherId: this.teacherId })
                .then((res) => {
                    if (res.status === "0") {
                        this.teacherInfo = res.data;
                    } else {
                        this.$message.error("Error!" + res.message);
                    }
                });
        },
        getCourseDetail() {
            this.$api.courseApi
                .getCoursesDetail({ courseId: this.courseId })
                .then((res) => {
                    if (res.status === "0") {
                        this.courseInfo = res.data;
                        this.courseInfo.covey_user.price = this.courseInfo.price;
                        
                    } else {
                        this.$message.error("Error!" + res.message);
                    }
                });
        },
        getCourseTimeList() {
            this.$api.courseApi
                .getCourseTime({
                    cId: this.courseId,
                    year: this.nowYear,
                    month: this.nowMonth + 1,
                })
                .then((res) => {
                    if (res.status === "0") {
                        this.courseTimeList = res.data;
                    } else {
                        this.$message.error("Error!" + res.message);
                    }
                });
        },
        checkItem(item) {
            for (let i = 0; i < this.checkedCourseList.length; i++) {
                if (this.checkedCourseList[i].id === item.id) {
                    this.checkedCourseList.splice(i, 1);
                    return;
                }
            }
            this.checkedCourseList.push(item);
            this.checkedCourseList.sort((a, b) => {
                if (new Date(a.apdate) > new Date(b.apdate)) {
                    return 1;
                } else if (new Date(a.apdate) < new Date(b.apdate)) {
                    return -1;
                } else {
                    return a.hour + a.period - (b.hour + b.period);
                }
            });
        },
        // 选择优惠券
        checkCoupon(item) {
            if (
                this.totalNum * this.unitPrice <
                (item.with_amount / 100).toFixed(2)
            ) {
                return;
            }
            if (this.selectedCoupon === item.id) this.selectedCoupon = "";
            else {
                this.selectedCoupon = item.id;
            }
        },
        //获取课程折扣
        getCoursePrice() {
            this.$api.courseApi
                .getCoursePrice({ courseId: this.courseId })
                .then((res) => {
                    if (res.status === "0") {
                        this.coursePrice = res.data;
                    } else {
                        this.$message.error("Error!" + res.message);
                    }
                });
        },
        handleBookOrder() {
            let t_calendars_arr = [];
            for (let child of this.checkedCourseList) {
                t_calendars_arr.push(child.id);
            }
            if (t_calendars_arr.length <= 0) {
                this.$message.error("Please select at least 1 session!");
                return;
            }
            this.$confirm("Placing an order?", "", {
                type: "warning",
            })
                .then(() => {
                    this.nextLoading = true;
                    let params = {
                        courseId: this.courseId,
                        teacherId: this.teacherId,
                        calendars: t_calendars_arr,
                        couponId: this.selectedCoupon,

                        price: parseInt(this.originalPrice * 100), //单价
                        pay_price: parseInt(this.unitPrice * 100), //折后价
                        pay_money: parseInt(this.total * 100), //待支付
                    };
                    if (!params.couponId) delete params.couponId;
                    return this.$api.courseApi.ordercourse(params);
                })
                .then((res) => {
                    this.nextLoading = false;
                    if (res.status === "0") {
                        this.step = 1;

                        this.$router.push({
                            path: this.$route.path,
                            query: {
                                orderId: res.data.orderId
                            }
                        })
                        this.orderId = res.data.orderId;
                        this.getOrderDetailById()
                    } else {
                        this.$message.error("Error!" + res.message);
                    }
                })
                .catch(() => { });
        },
        paytheOrder() {
            if (this.isFinishedPay) {
                this.$message.warning("Please do not click the payment button repeatedly to avoid repeated payment!");
            }
            this.paypalLoading = true;

            this.$api.orderApi.createPaypal({ orderId: this.orderId }).then((res) => {
                if (res.status === "0") {
                    this.$message.success(res.message, "Please wait");
                    this.isWaitingVisible = true;
                    
                            
                    if (res.data) {
                        if (isURL(res.data)) {
                            window.location.href = res.data
                        }

                    }
                } else {
                    this.$message.error("Error!" + res.message);
                }
                this.paypalLoading = false;
            });
        },
        //获取订单详情
        getOrderDetailById() {
            this.$api.orderApi.getOrderDetail({ orderId: this.orderId }).then(res => {
                if (res.status === '0') {
                    this.orderDetail = res.data;
                    this.courseInfo = res.data.covey_course;
                }
            })
        },

        //检查订单状态
        checkOrderDetailById() {
            // this.isWaitingVisible = true;
            this.$api.orderApi.getOrderById({ orderId: this.orderId }).then((res) => {
                if (res.status === "0") {
                    this.step = 1;
                    
                    this.getOrderDetailById();//获取订单详情
                    if (res.data) {//订单存在
                        this.orderDetail = res.data;
                        if (res.data.order_status === 2) {
                            this.isFinishedPay = true;//支付成功
                            this.$message.success("The order is paid successfully！");
                            // this.$router.push('/order/purchased')
                        } else {
                            this.isFinishedPay = false;
                        }
                    } else {
                        this.$message.error("Error! Order does not exist.");
                    }
                } else {
                    this.$message.error("Error!" + res.message);
                }
                // this.isWaitingVisible = false;
            });
        },

        refreshOrderStatus() {
            this.$api.orderApi.getOrderById({ orderId: this.orderId }).then((res) => {
                if (res.status === "0") {
                    this.isWaitingVisible = false;
                    if (res.data.order_status === 2) {
                        this.isFinishedPay = true;
                    } else {
                        this.isFinishedPay = false;
                    }
                } else {
                    this.$message.error("Error!" + res.message);
                }
            });
        },
        //上个月
        goPrevMonth() {
            let now = new Date(this.nowYear, this.nowMonth - 1);
            this.nowMonth = now.getMonth();
            this.nowYear = now.getFullYear();
            this.getCourseTimeList();

            if (
                new Date(this.nowYear, this.nowMonth) <
                new Date(new Date().setHours(0, 0, 0, 0))
            ) {
                this.canGoPre = true;
            } else {
                this.canGoPre = false;
            }
        },
        //下个月
        goNextMonth() {
            let now = new Date(this.nowYear, this.nowMonth + 1);
            this.nowMonth = now.getMonth();
            this.nowYear = now.getFullYear();
            this.getCourseTimeList();

            if (
                new Date(this.nowYear, this.nowMonth) <
                new Date(new Date().setHours(0, 0, 0, 0))
            ) {
                this.canGoPre = true;
            } else {
                this.canGoPre = false;
            }
        },
        showCheck(item) {
            
        },
        // 获取优惠券
        getcoupon() {
            this.$api.orderApi.getcoupon().then((res) => {
                if (res.status === "0") {
                    this.couponList = res.data.sort((a, b) => {
                        return a.with_amount - b.with_amount;
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.book-a-class {
    font-family: PingFangSC-Semibold, PingFang SC;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    transition: 0.2s;
    .el-dialog__wrapper {
        /deep/ .el-dialog__header {
            padding: 0 !important;
        }
        /deep/ .el-dialog__body {
            padding: 0 !important;
        }
        /deep/ .el-dialog {
            box-shadow: none !important;
            margin-top: 45vh !important;
            background: none !important;
            .refresh_tips {
                font-size: 16px;
                text-align: center;
                line-height: 1.5;
                color: #fff;

                word-wrap: break-word;
                word-break: normal;
            }
            .refresh_box {
                font-size: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 40px;
                color: #fff;
                cursor: pointer;
                .refresh_bt {
                    text-decoration: underline;
                    font-weight: bold;
                    &:hover {
                        color: #f48c06;
                    }
                }
            }
        }
    }
    .course-head {
        z-index: 10;
        color: #ffffff;
        box-sizing: border-box;
        width: 100%;
        padding: 11px 0;
        background: linear-gradient(270deg, #175fa8 0%, #0a3a76 100%);
        .course-title {
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            line-height: 30px;
        }
        .course-rate {
            height: 20px;
            margin-top: 8px;
            font-size: 14px;
            .el-rate {
                display: inline;
                margin-right: 16px;
            }
            span {
                color: #ffffff;
                vertical-align: middle;
            }
        }
    }
    .bookclass-body {
        height: 100%;
        padding: 24px 0;
        .left {
            flex: 4;
            flex: 5;
            .bookclass-body-title {
                height: 44px;
                font-size: 36px;
                font-weight: 600;
                color: #201002;
                line-height: 44px;
                display: flex;
                justify-content: space-between;
                background: rgba(0, 0, 0, 0);
                i {
                    cursor: pointer;

                    &:hover {
                        color: #f48c06;
                    }
                }
            }
            .bookclass-body-time {
                display: flex;
                justify-content: space-between;
                margin-top: 24px;
                .bookclass-time-date {
                    height: 25px;
                    font-size: 18px;
                    font-weight: 600;
                    color: #181d2c;
                    line-height: 25px;
                }
                .bookclass-time-oprate {
                    font-size: 18px;
                    .can-select {
                        color: #181d2c;
                        cursor: not-allowed !important;
                        pointer-events: none !important;
                    }
                    i {
                        cursor: pointer;
                        color: #f48c06;
                    }
                }
            }

            .select-box {
                margin-top: 16px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
            }
            .selected-box {
                margin-top: 16px;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
            }
            .coupon-disable {
                cursor: not-allowed !important;
                pointer-events: none !important;
            }
            .select-item-box {
                width: 100%;
            }
            .selected-item-box {
                width: 33.33%;
            }
            .select-item {
                margin-bottom: 16px;
                cursor: pointer;
                align-self: center;
                box-sizing: border-box;
                padding: 14px;
                height: 48px;
                background: rgba(32, 16, 2, 0.06);
                border-radius: 8px;
                font-size: 14px;
                font-weight: 600;
                color: #201002;
                display: flex;
                justify-content: space-between;
                &:hover {
                    background: rgba(32, 16, 2, 0.03);
                }
                span {
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
            /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #f48c06;
                border-color: #f48c06;
            }
            /deep/.el-checkbox__inner {
                &:focus,
                :hover {
                    border: 1px solid #f48c06 !important;
                    // border-color: #F48C06;
                }
            }
            /deep/.el-radio__label {
                display: none;
            }
        }

        .right {
            height: 100%;
            flex: 2;
            background: #ffffff;
            box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
            .order-back {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
                background: rgba(0, 0, 0, 0.7);
                display: flex;
                color: #fff;
                align-items: center;
                justify-content: center;
            }
            .bookclass-order-box {
                border-bottom: 1px solid rgba(126, 128, 136, 0.16);
                padding: 0 24px 24px;
                .bookclass-order-price {
                    padding: 15px 0;
                    border-bottom: 1px solid rgba(126, 128, 136, 0.16);
                    
                }
                .bookclass-order-total {
                    padding: 24px 0;
                }
            }
            .order-price-item {
                        height: 20px;
                        font-size: 14px;
                        font-weight: 600;
                        color: #181d2c;
                        line-height: 20px;
                        display: flex;
                        justify-content: space-between;
                        &:hover {
                            background: #f3f3f3;
                        }
                        div:nth-child(2) {
                            color: #f48c06;
                        }
                    }

            .bookclass-order-pay {
                padding: 16px 0;
                border-radius: 4px;
                background: rgba(126, 128, 136, 0.08);
                display: flex;
                justify-content: space-between;
                align-items: center;
                span {
                    height: 33px;
                    font-size: 24px;
                    font-weight: 600;
                    line-height: 33px;
                    color: #f48c06;
                }
                .tt,
                div {
                    height: 24px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #7e8088;
                    line-height: 24px;
                    margin-right: 8px;
                }
            }
            .bookclass-order-title {
                border-bottom: 1px solid rgba(126, 128, 136, 0.16);
                padding: 16px 24px;
                height: 25px;
                font-size: 18px;
                font-weight: 600;
                color: #181d2c;
                line-height: 25px;
            }
            .course-price-box {
                font-size: 14px;
                padding: 8px 24px;
                .course-price {
                    margin: 16px 0;
                }
            }
            .order-box {
                padding: 16px 24px;
                .order-fee_info {
                }
            }
        }
    }
    .right {
        .my-button {
            width: 100%;
            border: none;
            cursor: pointer;
            height: 48px;
            background: #f48c06;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            span {
                color: #ffffff;
                line-height: 20px;
            }
        }
        .success-pay {
            width: 100%;
            border: none;
            height: 48px;
            background: #f48c06;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 18px;
        }
        .my-card {
            margin: 20px 0;
            width: vw(300);
            min-width: 260px;
            height: 64px;
            background: #ffffff;
            box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
            border-radius: 8px;
            padding: vw(18) vw(90);
            box-sizing: border-box;
            img {
                align-self: center;
                width: 100%;
            }
        }
    }
}
</style>